import Script from "next/script";
import { stage } from "@/lib/env";
import { GTM_CONTAINER_IDS } from "@/lib/gtm";
import { META_PIXEL_ID } from "@/lib/meta-pixel";

/**
 * Google Tag Manager containers and the Meta Pixel. Mount only on public
 * acquisition surfaces (marketing site, signup/login, onboarding): these tags
 * run third-party code and report page URLs, so they stay off authenticated
 * CRM screens and tokenized pages such as /unsubscribe. Renders nothing
 * outside prod so ad platforms never see dev or staging traffic.
 */
export function AdTags() {
  if (stage !== "prod") {
    return null;
  }

  return (
    <>
      {GTM_CONTAINER_IDS.map((id) => (
        <Script key={id} id={`gtm-${id}`} strategy="afterInteractive">
          {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${id}');`}
        </Script>
      ))}
      <Script id="meta-pixel" strategy="afterInteractive">
        {`!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window,document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '${META_PIXEL_ID}');
fbq('track', 'PageView');`}
      </Script>
      <noscript>
        {GTM_CONTAINER_IDS.map((id) => (
          <iframe
            key={id}
            src={`https://www.googletagmanager.com/ns.html?id=${id}`}
            height="0"
            width="0"
            style={{ display: "none", visibility: "hidden" }}
          />
        ))}
        <img
          height="1"
          width="1"
          alt=""
          style={{ display: "none" }}
          src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`}
        />
      </noscript>
    </>
  );
}
